import { createApp } from 'vue';
import { registerPlugins } from '@/plugins';
import App from './app.vue';

const app = createApp(App);

registerPlugins(app);

app.mount('#app');

(window as any).API_BASE_URL = process.env.VITE_API_BASE_URL || '';
(window as any).CONTENT_BASE_URL = process.env.VITE_CONTENT_BASE_URL || '';
